import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Subscription } from 'rxjs'

import { MessageService } from '../../../services/message.service'

interface ModalData {
	title: string
	message: string
  }

@Component({
    selector: 'app-error-message-modal',
    templateUrl: './error-message-modal.component.html',
    styleUrls: ['./error-message-modal.component.scss'],
    standalone: false
})
export class ErrorMessageModalComponent implements OnInit 
{
	loginSessionExpiredSubscription: Subscription

	constructor(
		public dialogRef: MatDialogRef<ErrorMessageModalComponent>, @Inject(MAT_DIALOG_DATA) public data: ModalData,
		private messageService: MessageService
	) 
	{
		this.loginSessionExpiredSubscription = this.messageService.loginSessionExpired$.subscribe(() =>
		{
			this.closeModal()
		})
	}

	ngOnInit() 
	{
	}

	closeModal(): void 
	{
		this.dialogRef.close();
	}
}
